module.exports = __webpack_public_path__ + "static/heroVid-e82ede02f259f391923fe70f3da58ea3.mp4";